import { UserBots } from "@apis:user_bot/user_bot";
import { get, post } from "@libs:axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CamelCasedPropertiesDeep } from "type-fest";

import {
  GetOrganizationAdminsApiOrganizationAdminsGetData,
  OrganizationAdminGetSchema,
  OrganizationAdminsBatchRequest,
} from "@:openapi";

export interface OrganizationAdmin {
  GET_ALL: {
    RequestQuery: CamelCasedPropertiesDeep<
      GetOrganizationAdminsApiOrganizationAdminsGetData["query"]
    >;
    Response: CamelCasedPropertiesDeep<Array<OrganizationAdminGetSchema>>;
  };
  BATCH: {
    RequestBody: CamelCasedPropertiesDeep<OrganizationAdminsBatchRequest>;
    Response: unknown;
  };
}

export const organizationAdminQueryKey = createQueryKeys("organizationAdmin", {
  getAll: (params: OrganizationAdmin["GET_ALL"]["RequestQuery"]) => [params],
});

export const useQueryGetAllOrganizationAdmins = (
  params: OrganizationAdmin["GET_ALL"]["RequestQuery"],
  options?: Omit<
    UseQueryOptions<OrganizationAdmin["GET_ALL"]["Response"], AxiosError>,
    "queryKey"
  >,
) => {
  return useQuery<OrganizationAdmin["GET_ALL"]["Response"], AxiosError>({
    queryKey: organizationAdminQueryKey.getAll(params).queryKey,
    queryFn: () => {
      return get<OrganizationAdmin["GET_ALL"]["Response"]>(
        "/api/organization_admins",
        {
          ...params,
        },
      );
    },
    ...options,
  });
};

export const useMutationInsertDeleteOrganizationAdmins = (
  options?: UseMutationOptions<
    OrganizationAdmin["BATCH"]["Response"],
    AxiosError,
    OrganizationAdmin["BATCH"]["RequestBody"]
  >,
) => {
  return useMutation({
    mutationFn: (data: OrganizationAdmin["BATCH"]["RequestBody"]) => {
      return post<UserBots["BATCH"]["Response"]>(
        `/api/organization_admins/batch`,
        data,
      );
    },
    ...options,
  });
};
